<template>
  <DefaultLayout></DefaultLayout>
</template>
<script>
import DefaultLayout from '../layouts/default/';

export default {
  components: {
    DefaultLayout,
  },
  computed: {
    nextUrl() {
      return this.$route.params.nextUrl || '';
    },
  },
  mounted() {
    this.$bus.emit('show-sign-in', this.nextUrl, '', '', false);
  },
};
</script>
